/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { HFlow, Progress, Text, VFlow } from 'bold-ui'
import { useAlert } from 'components/alert'
import { usePubSub } from 'hooks/pubsub/usePubSub'
import { useCallback, useEffect, useState } from 'react'
import { useAsyncTerritorioProcessingPolling } from 'view/visualizacaoTerritorial/hooks/useAsyncTerritorioProcessingPolling'

interface AtualizacaoImoveisProgressBarProps {
  topic: string
  progressToken: string
  onCompleteCallBack: () => void
  renderProgressBar: boolean
}

type AtualizacaoImoveisMessageModel = { processed: number; total: number }

const TIME_OUT_IN_MS = 3000

export function AtualizacaoImoveisProgressBar({
  topic,
  progressToken,
  onCompleteCallBack,
  renderProgressBar,
}: AtualizacaoImoveisProgressBarProps) {
  const alert = useAlert()
  const [progress, setProgress] = useState({ processed: 0, total: 0 })

  const handleCompleteCallBack = useCallback(() => {
    onCompleteCallBack()
    alert('success', 'Imóveis atualizados com sucesso.')
  }, [onCompleteCallBack, alert])

  const { startPolling, stopPolling, resetPolling } = useAsyncTerritorioProcessingPolling({
    key: progressToken,
    timeOutMs: TIME_OUT_IN_MS,
    onProcessFinished: handleCompleteCallBack,
  })

  useEffect(() => {
    startPolling()
  })

  usePubSub<AtualizacaoImoveisMessageModel>({
    topic: `/${topic}`,
    onMessage: ({ processed, total }) => {
      resetPolling()
      const processedNormalized = processed > progress.processed ? processed : progress.processed
      setProgress({ processed: processedNormalized, total })
      if (processed === total) {
        stopPolling()
        handleCompleteCallBack()
      }
    },
  })

  return renderProgressBar ? (
    <VFlow vSpacing={0}>
      <Text css={styles.progressText}>{progress.processed ? 'Atualizando imóveis' : 'Aguardando na fila'}</Text>
      <HFlow style={styles.progressContainer}>
        <Progress max={progress.total} value={progress.processed} css={styles.progressBar} />
        <Text css={styles.progressText}>{`${progress.processed}/${progress.total}`}</Text>
      </HFlow>
    </VFlow>
  ) : null
}

const styles = {
  progressContainer: css`
    display: flex;
    padding: 0rem;
    width: 100%;
    align-items: center;
  `,
  progressBar: css`
    flex-grow: 1;
    margin-right: 0.5rem;
  `,

  progressText: css`
    flex-basis: auto;
    font-weight: bold;
  `,
}
